import React from 'react';
import EditableQuestion from './EditableQuestion';
import QuestionCreator from './QuestionCreator';
import axios from 'axios';

import * as Globals from './../Globals';


export default class SubjectView extends React.Component {

    constructor(props) {
        super(props);

        this.documentIDs = [];
        this.videoIDs = [];
        this.state = {
            name: "",
            questionIDs: [],
            createQuestion: false,
            documents: [],
            videos: [],
            videoPath: "",
            documentPath: "",
            deletingQuestionId: null,
            deletingQuestionText: null,
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.BASE_PATH + 'api/subjects/' + this.props.id,
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookie
                }
            })
            .then(response => {
                this.setState({
                    name: response.data.name
                });
            })
            .catch((error) => {
                this.props.CheckAuthError(error);
            });

        this.updateQuestions();
        this.updateDocuments();
        this.updateVideos();
    }

    refresh() {
        this.componentDidMount();
    }


    handleCloseCreator(refresh) {
        if (refresh)
            this.refresh();
        this.setState({
            createQuestion: false
        });
    }

    deleteDocument(index) {
        if (this.documentIDs.indexOf(index) !== -1) {
            let cookie = this.props.LogoutOnCookieNotSet();
            axios.delete(Globals.EL_PATH + 'document/' + index + '?Authentication=' + cookie
            ).then(() => {
                this.updateDocuments();
            }).catch((error) => {
                this.props.CheckAuthError(error);
            });
        } else {
            this.updateDocuments();
        }
    }

    deleteVideo(index) {
        if (this.videoIDs.indexOf(index) !== -1) {
            let cookie = this.props.LogoutOnCookieNotSet();
            axios.delete(Globals.EL_PATH + 'video/' + index + '?Authentication=' + cookie
            ).then(() => {
                this.updateVideos();
            }).catch((error) => {
                this.props.CheckAuthError(error);
            });
        } else {
            this.updateVideos();
        }
    }

    showDeleteQuestionModal = (id, text) => {
        this.setState({
            deletingQuestionId: id,
            deletingQuestionText: text
        });
        Globals.jquery('#questionDelete').modal('show');
    };

    deleteQuestion = () => {
        Globals.jquery('#questionDelete').modal('hide');
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.delete(Globals.EL_PATH + 'question/' + this.state.deletingQuestionId + '?Authentication=' + cookie
        )
            .then(() => {
                this.updateQuestions();
            })
            .catch(error => {
                this.props.CheckAuthError(error);
            });
    };

    updateDocuments() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'subject/' + this.props.id + '/document?Authentication=' + cookie
        ).then(response => {
            this.setState({
                documents: response.data.records
            });
            this.documentIDs = [];
            response.data.records.map(document => {
                this.documentIDs.push(document.id);
                return null;
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
            this.setState({
                documents: []
            });
            this.documentIDs = [];
        });
    }

    updateVideos() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'subject/' + this.props.id + '/video?Authentication=' + cookie
        ).then(response => {
            this.setState({
                videos: response.data.records
            });
            this.videoIDs = [];
            response.data.records.map(video => {
                this.videoIDs.push(video.id);
                return null;
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
            this.setState({
                videos: []
            });
            this.videoIDs = [];
        });
    }

    updateQuestions = () => {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'subject/' + this.props.id + '/question?Authentication=' + cookie
        ).then(response => {
            let questionIDs = [];
            response.data.records.forEach((question) => questionIDs.push(question.id));
            this.setState({
                questionIDs: questionIDs
            });
        }).catch((error) => {
            if (error.response.status === 404) {
                this.setState({
                    questionIDs: []
                });
            }
            this.props.CheckAuthError(error);
        });
    };

    getDocuments() {
        if (this.state.documents.length > 0) {
            return (
                <div>
                    <ul>
                        {
                            this.state.documents.map((document, index) =>
                                <li key={index} className="margin-bottom-xs">
                                    <a href={document.source} download
                                       target="_blank">{document.source.split("/")[document.source.split("/").length - 1]}</a>
                                    <span className="glyphicon glyphicon glyphicon-trash removeIcon"
                                          onClick={() => this.deleteDocument(document.id)}/>
                                </li>
                            )
                        }
                    </ul>
                </div>
            );
        } else {
            return (<p className="text-muted">Keine Dokumente gefunden</p>);
        }
    }

    addDocument(e) {
        let cookie = this.props.LogoutOnCookieNotSet();
        this.setState({
            documentPath: e.target.value
        });
        let formData = new FormData();
        formData.append('file', e.target.files[0]);
        axios.post(Globals.EL_PATH + 'subject/' + this.props.id + '/document?Authentication=' + cookie, formData,
            {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }).then(() => {
            this.setState({
                documentPath: ""
            });
            this.updateDocuments();
        }).catch((error) => {
            this.props.CheckAuthError(error);
        });
    }

    getVideos() {
        if (this.state.videos.length > 0) {
            return (
                <div>
                    <ul>
                        {
                            this.state.videos.map((video, index) =>
                                <li key={index} className="margin-bottom-xs">
                                    <a href={video.source} target="_blank">{video.source}</a>
                                    <span className="glyphicon glyphicon glyphicon-trash removeIcon"
                                          onClick={() => this.deleteVideo(video.id)}/>
                                </li>
                            )
                        }
                    </ul>
                </div>
            );
        } else {
            return (<p className="text-muted">Keine Videos gefunden</p>);
        }
    }

    handleVideoPathChange(e) {
        this.setState({
            videoPath: e.target.value
        });
    }

    addVideo() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.post(Globals.EL_PATH + 'subject/' + this.props.id + '/video?Authentication=' + cookie, {
            SOURCE: this.state.videoPath
        }).then(() => {
            this.setState({
                videoPath: ""
            });
            this.updateVideos();
        }).catch((error) => {
            this.props.CheckAuthError(error);
        });
    }

    getRenderBlock() {
        if (this.state.createQuestion) {
            return (
                <div className="container questionCreator">
                    <h1 className="text-center">{this.state.name}</h1>
                    <QuestionCreator CheckAuthError={this.props.CheckAuthError}
                                     LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} subjectID={this.props.id}
                                     sendCloseCreator={this.handleCloseCreator.bind(this)}/>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="modal fade" id="questionDelete" tabIndex="-1" role="dialog"
                         aria-labelledby="questionRemovalLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal"
                                            aria-label="Close"><span
                                        aria-hidden="true">&times;</span></button>
                                    <h4 className="modal-title" id="questionRemovalLabel">Frage wriklich löschen?</h4>
                                </div>
                                <div className="modal-body">
                                    {this.state.deletingQuestionText}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-default" data-dismiss="modal">Abbrechen
                                    </button>
                                    <button type="button" className="btn btn-primary"
                                            onClick={() => this.deleteQuestion()}>Bestätigen
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container subject">
                        <h1 className="text-center">{this.state.name}</h1>
                        <button className="btn btn-info center-block" type="button"
                                onClick={() => this.props.sendSubjectListRequest()}>Zur Fachübersicht
                        </button>

                        <div className="panel panel-default course-tests margin-bottom-lg">
                            <div className="panel-heading text-center"><h2>Lernmaterial</h2></div>
                            <ul className="list-group">
                                <li className="list-group-item padding-bottom-md">
                                    <h4>Dokumente</h4>
                                    {this.getDocuments()}
                                    <label>Dateiupload:</label>
                                    <input type="file" accept="application/pdf" value={this.state.documentPath}
                                           onChange={(e) => this.addDocument(e)}/>
                                </li>
                                <li className="list-group-item padding-bottom-md">
                                    <h4>Videos</h4>
                                    {this.getVideos()}
                                    <div className="input-group margin-top-sm">
                                        <input placeholder="Video Link" type="text" value={this.state.videoPath}
                                               onChange={(e) => this.handleVideoPathChange(e)}
                                               className="form-control"/>
                                        <span className="input-group-addon addVideoButton"
                                              onClick={() => this.addVideo()}>Video hinzufügen</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="panel panel-default course-tests">
                            <div className="panel-heading text-center"><h2>Fragen</h2></div>
                            <ul className="list-group">
                                {(this.state.questionIDs.length === 0) ?
                                    <li className="list-group-item"><p className="text-center" style={{margin: 0}}>Keine
                                        Fragen vorhanden...</p></li> : null}
                                {
                                    this.state.questionIDs.map((id) => {
                                        return (
                                            <EditableQuestion CheckAuthError={this.props.CheckAuthError}
                                                              LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet}
                                                              key={id} sendRefresh={this.refresh.bind(this)} id={id}
                                                              onDelete={this.showDeleteQuestionModal}/>
                                        );
                                    })
                                }
                            </ul>
                        </div>
                        <button className="btn btn-info center-block" type="button"
                                onClick={() => this.setState({createQuestion: true})}>Neue Frage
                        </button>
                    </div>
                </div>
            );
        }
    }

    render() {
        return (this.getRenderBlock());
    }

}



// WEBPACK FOOTER //
// ./src/admin/SubjectView.js